import { Group, Stack, type MantineSpacing } from '@mantine/core';

import type { ReactNode } from 'react';

const OPACITY_TRANSITION_DURATION = '200ms';

export type MessageActionsProps = {
  isHovered: boolean;
  children: ReactNode;
  /** Space between the actions. */
  gap?: MantineSpacing;
  /** Space above the row. */
  mt?: MantineSpacing;
};

export default function MessageActions({
  isHovered,
  children,
  gap = 'xs',
  mt = 'sm',
}: MessageActionsProps): ReactNode {
  return (
    <Stack gap="xs" mt={mt}>
      <Group
        gap={gap}
        style={{
          opacity: isHovered ? 1 : 0.2,
          transition: `opacity ${OPACITY_TRANSITION_DURATION} ease`,
        }}
      >
        {children}
      </Group>
    </Stack>
  );
}
